export const GET_ALL_VEEVA_CONFIG = `query($first:Int, $last:Int, $after:Cursor, $before:Cursor, $filter: VeevaEnvironmentConfigurationFilter) {
    allVeevaEnvironmentConfigurations(first:$first, last:$last, after:$after, before:$before, filter: $filter, orderBy:CREATED_AT_DESC) {
        nodes {
            id
            country
            countryType
            aemCountryNode
            identityType
            identityTypeName
            salesforceCountryCode
            veevaSpecilityFilter
            veevaInstanceType
            aemLanguageNode
        }
      	totalCount
        pageInfo{
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
    }
}`;

export const CREATE_VEEVA_CONFIG = `mutation($veevaEnvironmentConfiguration: VeevaEnvironmentConfigurationInput!) {
 createVeevaEnvironmentConfiguration(
    input: {
	    veevaEnvironmentConfiguration: $veevaEnvironmentConfiguration
    })  {
        veevaEnvironmentConfiguration {
            id
        }
    }
}`;

export const UPDATE_VEEVA_CONFIG = `mutation($id: UUID!, $veevaEnvironmentConfiguration: VeevaEnvironmentConfigurationPatch!) {
    updateVeevaEnvironmentConfigurationById(input: {
        id:$id, veevaEnvironmentConfigurationPatch:$veevaEnvironmentConfiguration}) {
        veevaEnvironmentConfiguration {
            id
            country
            countryType
            aemCountryNode
            identityType
            identityTypeName
            salesforceCountryCode
            veevaSpecilityFilter
            veevaInstanceType
            aemLanguageNode
        }
    }
}`;

export const DELETE_VEEVA_CONFIG = `mutation($id:UUID!) {
	deleteVeevaEnvironmentConfigurationById(input:{id: $id}) {
        veevaEnvironmentConfiguration {
            id
        }
    }
}`;
